export const appendAutoPlay = iframe =>
  // splits iframe tag by spaces then appends the src tag string with autoplay=1iframe
  iframe
    .split(' ')
    .map((tag, i) =>
      tag.startsWith('src=') ? `${tag.slice(0, -1)}&autoplay=1"` : tag
    )
    .join(' ');
